export default __webpack_public_path__ + "static/media/KG.350173f1.svg";